// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import store from './store';
import ElementUI from 'element-ui';
import Moment from 'moment';
import VueMoment from 'vue-moment';
import 'element-ui/lib/theme-chalk/index.css';
import 'font-awesome/css/font-awesome.css';
import './css/common.scss';
import './css/reset.scss';
import App from './App';
import router from './router';
import axios from './config/axios.config';
import Viewer from 'v-viewer';

import codepku from './js/codepku.js';
import franchisee from './js/permissions.js';
import common from './js/common.js';
import DataSource from './js/datasource.js';

Vue.config.productionTip = false;
window.moment = Moment;
Vue.use(ElementUI);
Vue.use(Viewer, {
    defaultOptions: {}
});
Vue.use(VueMoment, Moment);
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    axios,
    store,
    components: {App},
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js